<template>
	<div class="about-info">
		<div class="page-container">
			<PageTitle ch="參觀資訊" en="Visiting Information"></PageTitle>
			<BannerSplit2AboutInfo></BannerSplit2AboutInfo>
			<BannerSplit2AboutInfoEn style="margin-top: 15px"></BannerSplit2AboutInfoEn>
			<PageTitle ch="偶戲村常態活動" en="Regular Activities"></PageTitle>

			<b-row class="activity">
				<b-col class="a-item" lg="3" md="6" sm="12">
					<div class="inner">
						<div class="title">拜訪戲偶家族</div>
						<div class="content">
							<div class="up">近距離觀賞各類型的戲偶，細看其中的迷人之處。</div>
							<div class="down">
								<b-row class="nowrap">
									<b-col>時間
										<span class="seg">|</span>
									</b-col>
									<b-col>開放日全時段</b-col>
								</b-row>
							</div>

						</div>
					</div>
				</b-col>
				<b-col class="a-item" lg="3" md="6" sm="12">
					<div class="inner">
						<div class="title">操偶師職人實境體驗</div>
						<div class="content">
							<div class="up">由村民帶領，體驗在偶戲村創作生活的日常，一同探索由古老舊穀倉大改造的偶戲藝術村。</div>
							<div class="down">
								<b-row>
									<b-col cols="8">時間
										<span class="seg">|</span>開放日</b-col>
									<b-col cols="4">
										<b-row class="d-flex justify-content-end" style="padding: 0 15px">
											<ul>
												<li>11:00</li>
												<li>15:00</li>
											</ul>
										</b-row>
									</b-col>
								</b-row>
								<p style="text-align: right">每場50-60分鐘</p>
								<router-link to="/reservation/secret" tag="span" class="apply-btn">操偶師職人實境體驗</router-link>
							</div>

						</div>
					</div>
				</b-col>
				<b-col class="a-item" lg="3" md="6" sm="12">
					<div class="inner">
						<div class="title">偶們的故事時光</div>
						<div class="content">
							<div class="up">由偶戲村村民帶領大家一起徜徉繪本的奇妙世界。</div>
							<div class="down">
								<b-row class="nowrap">
									<b-col>時間
										<span class="seg">|</span>
									</b-col>
									<b-col style="text-align: right">詳情請看</b-col>
								</b-row>
								<router-link to="/event/list" tag="span" class="apply-btn">展演活動</router-link>
							</div>

						</div>
					</div>
				</b-col>
				<b-col class="a-item" lg="3" md="6" sm="12">
					<div class="inner">
						<div class="title">偶戲村學堂</div>
						<div class="content">
							<div class="up">各式肢體戲劇課程、手藝創作DIY體驗等，適合親子一同體驗玩樂，也適合民眾自我充實學習。</div>
							<div class="down">
								<b-row class="nowrap">
									<b-col>時間
										<span class="seg">|</span>
									</b-col>
									<b-col style="text-align: right">詳情請看</b-col>
								</b-row>
								<router-link to="/event/list" tag="span" class="apply-btn">展演活動</router-link>
							</div>

						</div>
					</div>
				</b-col>
			</b-row>
			<b-row class="activity">
				<b-col class="a-item" lg="3" md="6" sm="12">
					<div class="inner">
						<div class="title">Visit Puppet Families</div>
						<div class="content">
							<div class="up">Experience and engage with the different types of puppets</div>
							<div class="down">
								<b-row class="nowrap">
									<b-col>Time
										<span class="seg">|</span>
									</b-col>
									<b-col>Permanent<br>exhibition</b-col>
								</b-row>
							</div>

						</div>
					</div>
				</b-col>
				<b-col class="a-item" lg="3" md="6" sm="12">
					<div class="inner">
						<div class="title">Guided Tour</div>
						<div class="content">
							<div class="up">Explore and experience the daily life in the art colony where old barns were renovated as space of art and explorations.</div>
							<div class="down">
								<b-row>
									<b-col cols="8">Time
										<span class="seg">|</span>Opening days</b-col>
									<b-col cols="4">
										<b-row class="d-flex justify-content-end" style="padding: 0 15px">
											<ul>
												<li>11:00</li>
												<li>15:00</li>
											</ul>
										</b-row>
									</b-col>
								</b-row>
								<p style="text-align: right"> 50-60 minutes each time</p>
								<router-link to="/reservation/secret" tag="span" class="apply-btn">Information</router-link>
							</div>

						</div>
					</div>
				</b-col>
				<b-col class="a-item" lg="3" md="6" sm="12">
					<div class="inner">
						<div class="title">Our Story Time</div>
						<div class="content">
							<div class="up">Enjoy the wonderful world of the picture books.</div>
							<div class="down">
								<b-row class="nowrap">
									<b-col>Times
										<span class="seg">|</span>
									</b-col>
									<b-col style="text-align: right">Check</b-col>
								</b-row>
								<router-link to="/event/list" tag="span" class="apply-btn">Past Events Page</router-link>
							</div>

						</div>
					</div>
				</b-col>
				<b-col class="a-item" lg="3" md="6" sm="12">
					<div class="inner">
						<div class="title">Lize Lecture </div>
						<div class="content">
							<div class="up">A variety of workshops and short classes like handicraft, creative theater activities, physical movement sessions are offered for kids, family, groups or individuals.</div>
							<div class="down">
								<b-row>
									<b-col class="nowrap">Time
										<span class="seg">|</span>
									</b-col>
									<b-col style="text-align: right">Check</b-col>
								</b-row>
								<router-link to="/event/list" tag="span" class="apply-btn">Past Events Page</router-link>
							</div>

						</div>
					</div>
				</b-col>
			</b-row>
			<Slider class="about-info-carousol" :data="sliderData"></Slider>
			<PageTitle ch="入村須知" en=""></PageTitle>
			<ul class="know">
				<li>請勿攜帶寵物（導盲犬除外）入館參觀。</li>
				<li>偶戲村全區禁菸。</li>
				<li>為維護參觀品質和安全，未經許可請勿碰觸、破壞展示品或設施，也請勿於展場內奔跑嬉戲。若未確實遵守規範事項，造成本場館設施或展品有任何損傷或毀壞者，本場館保留求償的權利。</li>
				<li>展場展品皆歡迎拍照、錄影和親朋好友分享。如有特殊用途商業拍攝請事先申請。</li>
				<li>偶戲村內無設置障礙設施，若有需要特殊服務建議參訪前先來電詢問或告知現場工作人員。</li>
				<li>如因天災、事變或其他不可抗力因素，偶戲村得以停止開放部分或全部展場或空間。</li>
				<li>以上規範，若有任何變動或更正，請以本場館之公告為主。</li>
			</ul>
			<PageTitle ch="Notice" en=""></PageTitle>
			<ul class="know">
				<li>Pets are not allowed in the area, except guide dogs.</li>
				<li>No smoking in whole area.</li>
				<li>To respect other visitors’ right and safety, please do not touch and break the collections or facilities. Also, please do not run in the exhibition hall. Anyone that disobeys regulations will be claimed.</li>
				<li>Filming and photography are welcome. If the photographs or recordings are for commercial or special purposes, it’s a must to have a permission in advance.</li>
				<li>There is no accessible facility in our area. Please contact us in advance or ask our staff for assistance.</li>
				<li>The Lize Puppet Art Colony will close parts of spaces or the whole area due to a serious disaster, accident, or other unpredictable factors.</li>
				<li>The Lize Puppet Art Colony has the right to update or modify the regulations above.</li>
			</ul>
			<MapSplit2AboutInfo></MapSplit2AboutInfo>
		</div>
	</div>
</template>


<script>
import PageTitle from '@/components/page_title'
import BannerSplit2AboutInfo from '@/components/banner/banner_split2_about_info'
import BannerSplit2AboutInfoEn from '@/components/banner/banner_split2_about_info_en'
import MapSplit2AboutInfo from '@/components/map_split2_about_info'
import Slider from '@/components/slider'
export default {

	metaInfo: {
		title: '利澤國際偶戲藝術村'
	},
	name: 'about-info',
	data() {
		return {
			sliderData: [
				"/static/assets/about/info/img_event_1.png",
				"/static/assets/about/info/img_event_2.png",
				"/static/assets/about/info/img_event_3.png",
				"/static/assets/about/info/img_event_4.png",
				"/static/assets/about/info/img_event_5.png"
			]
		}
	},
	components: {
		PageTitle,
		BannerSplit2AboutInfo,
		BannerSplit2AboutInfoEn,
		Slider,
		MapSplit2AboutInfo
	},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="sass">
  @import '../../stylesheet/base.sass'
  @import '../../stylesheet/layout.sass'

  .about-info
    .apply-btn
      font-size: 14px
      padding: 1px 8px
      border-radius: 100px
      background-color: #01b6e2
      cursor: pointer
      color: white
      float: right
    .activity
      width: 100%
      max-width: 1440px
      margin: 0 auto
      padding: 0 20px
      .a-item
        padding: 10px

        .inner
          +flexLayout('start2', 'col')
          min-height: 350px
          height: 100%
          padding: 38px 20px 20px 20px
          background-color: #edfbff
          line-height: 2
          text-align: justify

          .content
            width: 100%
          .title
            font-size: $font-size-1
            font-weight: 500
            margin: 0px 0 40px 0
          .up
            min-height: 80px
          .down
            white-space: nowrap
            margin-top: 15px
            .seg
              color: #01b6e2
              margin-left: 5px
              margin-right: 5px
            p
              line-height: 3
            .nowrap
              flex-wrap: nowrap

    .about-info-carousol
      margin: 58px 0
    .know
      width: 100%
      max-width: 780px
      margin: 0 auto
      font-size: $font-size-3-s
      line-height: 1.6
      margin-bottom: 110px
      @media screen and (max-width: 996px)
        padding: 0 40px
      li
        position: relative
        &:before
          content: "・"
          color: #01b6e2
          margin-right: 5px
          position: absolute
          font-size: 20px
          left: -20px
          top: 0


</style>



// WEBPACK FOOTER //
// src/pages/about/about_info.vue